import {
  CURRENCY_TYPE_ENUM,
  ECOM_EXTERNAL_CONNECTION_TYPE_ENUM
} from '../../../../config/constants';

const config = {
  title: 'Printify',
  domain: 'https://printify.com/',
  description: 'Connect to Printify to manage your products and orders.',
  pkEcomExternalConnectionType: ECOM_EXTERNAL_CONNECTION_TYPE_ENUM.PRINTIFY,
  currencyType: CURRENCY_TYPE_ENUM.USD,
  routeValue: 'printify',
  products: {
    dashboardUrl: 'https://printify.com/app/store/products',
    getProductUrl: (ecomVendorProduct) =>
      `https://printify.com/app/product-details/${
        ecomVendorProduct?.ecomVendorProductExternalIds?.find(
          (i) =>
            i.fkEcomExternalConnectionType.toString() ===
            ECOM_EXTERNAL_CONNECTION_TYPE_ENUM.PRINTIFY.toString()
        )?.externalId
      }`,
    getProductUrlById: (id) => `https://printify.com/app/product-details/${id}`,
    filterOptions: [
      {
        label: 'Shops',
        placeholder: 'Select a shop',
        type: 'select',
        optionField: 'printify-shops',
        requestField: 'externalId',
        required: true
      }
    ],
    restrictions: {
      canChangeImages: false,
      canDuplicate: false,
      canCreateVariants: false,
      canCreateInputs: false,
      canManageInventory: false,
      canManageShipping: false,
      canChangeCurrency: false,
      canChangePrice: false,
      canChangeSku: false,
      canCustomizeDesign: false
    },
    formStateThatRequiresSync: [
      {
        key: 'name',
        title: 'Title',
        type: 'product',
        valueType: 'string'
      },
      {
        key: 'description',
        title: 'Description',
        type: 'product',
        valueType: 'string'
      },
      {
        key: 'sku',
        title: 'SKU',
        type: 'variant',
        valueType: 'string'
      },
      {
        key: 'price',
        title: 'Price',
        type: 'variant',
        valueType: 'currency'
      }
    ]
  },
  shippingOptions: [
    {
      value: '1',
      label: 'Standard',
      description: '2-5 business days'
    },
    {
      value: '2',
      label: 'Priority',
      description: '2-3 business days'
    },
    {
      value: '3',
      label: 'Express',
      description: '2-3 business days (incl. production)'
    },
    {
      value: '4',
      label: 'Economy',
      description: '4-8 business days'
    }
  ]
};

export { config };
